// extracted by mini-css-extract-plugin
module.exports = {"ContentLayout":"ContentLayout-module--ContentLayout--ZsOXy","Container":"ContentLayout-module--Container--3G6Tv"};